module.exports = [
    '$templateCache',
function (
    $templateCache
) {
    $templateCache.put('uib/template/pagination/pagination.html', require('./uib-pagination.html'));
}];



// WEBPACK FOOTER //
// ./app/common/configs/ui-bootstrap-template-decorators.js